import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as runReducer from "containers/Run/reducer";
import * as setupReducer from "containers/Setup/reducer";

import DateRangeSelect from "components/ForecastChart/DateRangeSelect";

class DateRangeSelectContainer extends React.PureComponent {
  render() {
    return <DateRangeSelect {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateForecastChartDateRange: (dateRange) =>
      dispatch(runReducer.updateForecastChartDateRange(ownProps.id, dateRange))
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    forecastChartDateRange: runReducer.getForecastChartDateRange(state, ownProps.id),
    forecastPredictionPlot: runReducer.getForecastPredictionPlot(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(DateRangeSelectContainer);
